 export class WaitingListInfoDTO {
    id:number;
    inscriptionId: number;
    name: string;
    surname: string
    email: string;
    phone: string;
    people: number;
    groupId: number | null;
    alreadyInscribed?: number
    accesCode?: string;
    inscribingNow?: number
     userId?: number;

 }
